export default "__VITE_ASSET__CBf8p4Rk__"